import functionKamarPage from "./kamar";
import articleDetail from "./articleDetail";
import rekananPageJs from "./rekanan";
import functionLanding from "./landingPage";
import functionModalBanner from "./modalBanner";

(function () {
    "use strict";

    //  Button Selanjutnya
    $(".btn-selanjutnya").on("click", () => {
        window.location.href = "/about";
    });

    // Reduce Oversized Text
    // const featuredFacilities = document.querySelectorAll('.featured-services .icon-box')
    // featuredFacilities.forEach(el => {
    //   let eachElement = el.querySelector('.description')

    //   if (eachElement.innerHTML.length > 200) {
    //     let sliceCurrentText = eachElement.innerHTML.slice(0, 200)
    //     sliceCurrentText += '......'
    //     eachElement.innerHTML = sliceCurrentText
    //   }
    // })

    /**
     * Easy selector helper function
     */
    const select = (el, all = false) => {
        el = el.trim();
        if (all) {
            return [...document.querySelectorAll(el)];
        } else {
            return document.querySelector(el);
        }
    };

    /**
     * Easy event listener function
     */
    const on = (type, el, listener, all = false) => {
        let selectEl = select(el, all);
        if (selectEl) {
            if (all) {
                selectEl.forEach((e) => e.addEventListener(type, listener));
            } else {
                selectEl.addEventListener(type, listener);
            }
        }
    };

    /**
     * Easy on scroll event listener
     */
    const onscroll = (el, listener) => {
        el.addEventListener("scroll", listener);
    };

    /**
     * Navbar links active state on scroll
     */
    let navbarlinks = select("#navbar .scrollto", true);
    const navbarlinksActive = () => {
        let position = window.scrollY + 200;
        navbarlinks.forEach((navbarlink) => {
            if (!navbarlink.hash) return;
            let section = select(navbarlink.hash);
            if (!section) return;
            if (
                position >= section.offsetTop &&
                position <= section.offsetTop + section.offsetHeight
            ) {
                navbarlink.classList.add("active");
            } else {
                navbarlink.classList.remove("active");
            }
        });
    };
    window.addEventListener("load", navbarlinksActive);
    onscroll(document, navbarlinksActive);

    /**
     * Scrolls to an element with header offset
     */
    const scrollto = (el) => {
        let header = select("#header");
        let offset = header.offsetHeight;

        let elementPos = select(el).offsetTop;
        window.scrollTo({
            top: elementPos - offset,
            behavior: "smooth",
        });
    };

    /**
     * Toggle .header-scrolled class to #header when page is scrolled
     */
    let selectHeader = select("#header");
    let selectTopbar = select("#topbar");
    if (selectHeader) {
        const headerScrolled = () => {
            if (window.scrollY > 100) {
                selectHeader.classList.add("header-scrolled");
                if (selectTopbar) {
                    selectTopbar.classList.add("topbar-scrolled");
                }
            } else {
                selectHeader.classList.remove("header-scrolled");
                if (selectTopbar) {
                    selectTopbar.classList.remove("topbar-scrolled");
                }
            }
        };
        window.addEventListener("load", headerScrolled);
        onscroll(document, headerScrolled);
    }

    /**
     * Back to top button
     */
    let backtotop = select(".back-to-top");
    if (backtotop) {
        const toggleBacktotop = () => {
            if (window.scrollY > 100) {
                backtotop.classList.add("active");
            } else {
                backtotop.classList.remove("active");
            }
        };
        window.addEventListener("load", toggleBacktotop);
        onscroll(document, toggleBacktotop);
    }

    /**
     * Mobile nav toggle
     */
    on("click", ".mobile-nav-toggle", function (e) {
        select("#navbar").classList.toggle("navbar-mobile");
        this.classList.toggle("bi-list");
        this.classList.toggle("bi-x");
    });

    /**
     * Mobile nav dropdowns activate
     */
    on(
        "click",
        ".navbar .dropdown > a",
        function (e) {
            if (select("#navbar").classList.contains("navbar-mobile")) {
                e.preventDefault();
                this.nextElementSibling.classList.toggle("dropdown-active");
            }
        },
        true
    );

    /**
     * Scrool with ofset on links with a class name .scrollto
     */
    on(
        "click",
        ".scrollto",
        function (e) {
            if (select(this.hash)) {
                e.preventDefault();

                let navbar = select("#navbar");
                if (navbar.classList.contains("navbar-mobile")) {
                    navbar.classList.remove("navbar-mobile");
                    let navbarToggle = select(".mobile-nav-toggle");
                    navbarToggle.classList.toggle("bi-list");
                    navbarToggle.classList.toggle("bi-x");
                }
                scrollto(this.hash);
            }
        },
        true
    );

    /**
     * Scroll with ofset on page load with hash links in the url
     */
    window.addEventListener("load", () => {
        if (window.location.hash) {
            if (select(window.location.hash)) {
                scrollto(window.location.hash);
            }
        }
    });

    /**
     * Preloader
     */
    let preloader = select("#preloader");
    if (preloader) {
        window.addEventListener("load", () => {
            preloader.remove();
        });
    }

    /**
     * Hero carousel indicators
     */
    let heroCarouselIndicators = select("#hero-carousel-indicators");
    let heroCarouselItems = select("#heroCarousel .carousel-item", true);

    if (heroCarouselIndicators) {
        heroCarouselItems.forEach((item, index) => {
            index === 0
                ? (heroCarouselIndicators.innerHTML +=
                      "<li data-bs-target='#heroCarousel' data-bs-slide-to='" +
                      index +
                      "' class='active'></li>")
                : (heroCarouselIndicators.innerHTML +=
                      "<li data-bs-target='#heroCarousel' data-bs-slide-to='" +
                      index +
                      "'></li>");
        });
    }

    /**
     * Testimonials slider
     */

    window.testimonialSlider = function () {
        window.onload = function () {
            new Swiper(".testimonials-slider", {
                speed: 600,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                slidesPerView: "auto",
                pagination: {
                    el: ".swiper-pagination",
                    type: "bullets",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },

                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                },
            });
        };
    };

    /**
     * Clients Slider
     */
    window.clientSlider = function () {
        new Swiper(".clients-slider", {
            speed: 400,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            slidesPerView: "auto",
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
                480: {
                    slidesPerView: 3,
                    spaceBetween: 60,
                },
                640: {
                    slidesPerView: 4,
                    spaceBetween: 80,
                },
                992: {
                    slidesPerView: 6,
                    spaceBetween: 120,
                },
            },
        });
    };

    /**
     * Clients Slider
     */
    window.galerySlider = function () {
        new Swiper(".gallery-slider", {
            speed: 400,
            loop: true,
            centeredSlides: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            slidesPerView: "auto",
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 100,
                },
            },
        });
    };

    /**
     * Initiate gallery lightbox
     */
    const galleryLightbox = GLightbox({
        selector: ".gallery-lightbox",
    });

    /**
     * Animation on scroll
     */
    window.addEventListener("load", () => {
        AOS.init({
            duration: 1000,
            easing: "ease-in-out",
            once: true,
            mirror: false,
        });
    });

    window.dokterPage = function () {
        const tablePoliKandungan = $("#table-poli-kandungan");
        const tablePoliAnak = $("#table-poli-anak");
        const tablePoliLaktasi = $("#table-poli-laktasi");
        const listTableChoices = $("#dokter .custom-card");

        const resetButton = () => {
            tablePoliKandungan.toggle(true);
            tablePoliAnak.toggle(true);
            tablePoliLaktasi.toggle(true);
        };

        const setActiveButton = (val) => {
            for (let i = 0; i < listTableChoices.length; i += 1) {
                if (i == val) {
                    listTableChoices[i].classList.add("active");
                } else {
                    listTableChoices[i].classList.remove("active");
                }
            }
        };

        const checkChoosedTable = (val) => {
            if (val == 1) {
                tablePoliAnak.toggle(false);
                tablePoliLaktasi.toggle(false);
            } else if (val == 2) {
                tablePoliKandungan.toggle(false);
                tablePoliLaktasi.toggle(false);
            } else if (val == 3) {
                tablePoliKandungan.toggle(false);
                tablePoliAnak.toggle(false);
            }
        };

        listTableChoices.on("click", function () {
            let choosedTable =
                listTableChoices[$(listTableChoices).index(this)].attributes
                    .value.value;

            resetButton();
            setActiveButton(choosedTable);
            checkChoosedTable(choosedTable);
        });
    };

    window.kamarPage = function (id) {

        functionKamarPage.handleChooseKamar();
        functionKamarPage.kamarSlider(id);
        //functionKamarPage.kamarLightBox();
    };

    window.getUrlVars = function ()
    {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for(var i = 0; i < hashes.length; i++)
        {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    // window.kamarPageA = function (id) {

    //     functionKamarPage.handleChooseKamar();
    //     functionKamarPage.kamarSlider(id);
    // };

    // window.kamarPageB = function (id) {

    //     functionKamarPage.handleChooseKamar();
    //     functionKamarPage.kamarSlider(id);
    // };

    // window.kamarPageC = function (id) {

    //     functionKamarPage.handleChooseKamar();
    //     functionKamarPage.kamarSlider(id);
    // };

    window.articleDetailPage = () => {
        articleDetail.handleAnotheArticleDetail();
    };

    window.convertDate = () => {
        articleDetail.convertDate();
    };

    window.rekananPage = () => {
        rekananPageJs.handleSearchRekanan();
    };

    window.landingPage = () => {
        functionLanding.handleChooseArticleLanding();
        functionLanding.handleClickCategoryArticlePage();
        functionLanding.handleDetailArticle();
    };

    window.functionModalBanner = () => {
        functionModalBanner.openModalBanner();
        functionModalBanner.closeModalBanner();
        functionModalBanner.bannerSlider();
        functionModalBanner.handleDetailBanner();
    };
})();
